import { alpha, makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  rootContainer: {
    display: 'flex',
    flexFlow: 'column nowrap',
    width: '100%',
    alignItems: 'center',
    height: '100%',
    maxHeight: '100%',
    overflow: 'hidden',
    backgroundImage: theme.gradiants.control,
  },
  scheduleInfoContainer: {
    position: 'relative',
    alignSelf: 'center',
    width: 352,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    flex: 1,
    height: '100%',
    maxHeight: '100%',
    minHeight: 0,
    overflow: 'auto',
    maxWidth: '478px',
    boxSizing: 'border-box',
    padding: '8px',
    scrollbarGutter: 'stable',
  },
  errorLabelStyle: {
    fontFamily: 'Roboto',
    color: '#D32F2F',
    fontSize: '14px',
    fontWeight: 'bold',
    textAlign: 'center',
    marginTop: '10px',
    minHeight: '20px',
  },
  timeContainer: {
    height: '28px',
    width: '75px',
    color: '#fdfdfe',
    borderRadius: '6px',
    backgroundColor: '#FFFFFF1A',
    padding: '6px 8px',
    margin: '5px',
    fontSize: '14px',
    '&:hover': {
      backgroundColor: '#FFFFFF1A',
      color: '#fdfdfe',
    },
  },
  selectModeStyle: {
    color: '#fdfdfe',
    fontSize: '16px',
    lineHeight: '1',
    fontWeight: 'normal',
    width: '100%',
    wordWrap: 'break-word',
    minWidth: 0,
    padding: '10px 16px',
  },
  container: {
    width: '100%',
    color: 'rgb(255,255,255)',
    padding: '9px 10px 16px 10px',
    borderRadius: '6px',
    background: alpha('#fdfdfe', 0.1),
    marginTop: '20px',
    maxWidth: '768px',
    minHeight: 'max-content',
  },

  daysRow: {
    height: 'auto !important',
    flexDirection: 'column',
    alignItems: 'flex-start !important',
    justifyContent: 'space-between',
    padding: '0 !important',
  },

  nameRow: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 15,
  },

  bodyRow: {
    alignSelf: 'stretch',
    background: alpha('#fdfdfe', 0.1),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '8px',
    padding: '0 10px 0 0',
    borderRadius: '6px',
    height: '43px',
  },
  controlSec: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    height: '100%',
  },
  bigIconBtnStyle: {
    width: 40,
    height: 40,
    borderRadius: 6,
    padding: 0,
  },
  headerStyle: {
    width: '100%',
    background: theme.gradiants.control,
    boxShadow: '0px 5px 9px 0 rgba(0, 0, 0, 0.2)',
    display: 'flex',
    height: 85,
    padding: 20,
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 10,
  },
  timeSelected: {
    border: `solid 1px ${theme.palette.secondary.main}`,
  },
  redBtn: {
    width: '110px',
    height: '40px',
    minHeight: '40px',
    borderRadius: '6px',
    boxShadow: '0 2px 3px 0 rgba(0, 0, 0, 0.1)',
    textTransform: 'none',
    backgroundColor: theme.palette.secondary.main,
    border: 0,
    '&:hover': {
      backgroundColor: alpha(theme.palette.secondary.main, 0.7),
      border: 0,
    },
    '&:focus': {
      backgroundColor: '#b3b3b3',
      border: 0,
    },
    '&:active': {
      backgroundColor: theme.palette.secondary.main,
      border: 0,
    },
    '&:disabled': {
      color: '#fdfdfe !important',
      opacity: 0.4,
      backgroundColor: `${theme.palette.secondary.main} !important`,
    },
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: 'normal',
    letterSpacing: 'normal',
    color: '#ffffff',
  },
  deleteButton: {
    width: '100%',
    height: '56px',
    borderRadius: '6px',
    boxShadow: '0 2px 3px 0 rgba(0, 0, 0, 0.1)',
    textTransform: 'none',
    backgroundColor: '##FFFFFF1C !important',
    border: 0,
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: 'normal',
    letterSpacing: 'normal',
    color: '#F05146',
    marginTop: '16px',
  },
  inputClass: {
    '& input': {
      color: '#fdfdfe',
    },
    width: '260px',
    fontSize: '16px',
    color: '#fdfdfe',
    borderColor: `${'rgba(255, 255, 255, 0.3)'} !important`,
    '& input + fieldset': {
      borderColor: `${'rgba(255, 255, 255, 0.3)'} !important`,
    },
    '& input:disabled + fieldset': {
      borderColor: `${'rgba(255, 255, 255, 0.3)'} !important`,
    },
    '& ::placeholder': {
      color: '#fdfdfe',
      opacity: 0.5,
      fontSize: '16px',
      lineHieght: 'normal',
      fontWeight: 'normal',
    },
    '& label': {
      color: `${'#fdfdfe'} !important`,
    },
  },

  tabContainer: {
    width: '100%',
    color: 'rgb(255,255,255)',
    padding: '9px 10px 16px 10px',
    borderRadius: ' 0 0 6px 6px',
    background: alpha('#fdfdfe', 0.1),
    minHeight: 'max-content',
  },

  editableRow: {
    background: alpha('#F0F0F0', 0.4),
  },

  rightSection: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },

  iconButton: {
    color: alpha('#fdfdfe', 0.7),
  },

  selectStyle: {
    fontSize: '14px',
    background: 'transparent',
    position: 'relative',


    '& .select-trigger': {
      color: '#FFFFFF99 !important',
      background: 'transparent',
      border: 'none !important',
      outline: 'none !important',
    },
    '& .select-arrow-icon': {
      color: '#FFFFFF99 !important',
      fill: '#FFFFFF99 !important',  // <-- Override CSS-module fill style
      width: '24px !important',       // <-- Override CSS-module width
      height: '24px !important',
      right: 0,
    },
    '& .select-placeholder': {
      color: '#FFFFFF99 !important',
    }
  },

  optionsList: {
    color: '#FFFFFF99 !important',
    WebkitTextFillColor: '#fdfdfe !important',
    backgroundColor: '#513E52 !important',
  },

  selectOption: {
    fontSize: '15px !important',
    padding: '6px 16px !important',
    height: '48px !important',
    display: 'flex !important',
    alignItems: 'center !important',
    justifyContent: 'center !important',
  },

  selectMenuPaper: {
    marginTop: '10px',
    background: '#513E52',
    color: '#fff',
    borderRadius: '6px',
  },



  selectMenuItem: {
    color: '#fff',
    fontSize: '15px',
    '&.Mui-selected': {
      backgroundColor: alpha('#FFFFFF', 0.1),
    },
    '&.Mui-focusVisible': {
      backgroundColor: alpha('#FFFFFF', 0.1),
      color: '#fff',
    },
    '&:hover': {
      backgroundColor: '#FFFFFF2E !important',
      color: '#fff',
    },
  },

  inputStyle: {
    width: '40px',
    '& .MuiInputBase-input': {
      color: '#fdfdfe !important',
    },
    '& .MuiInputBase-input.Mui-disabled': {
      color: '#fdfdfe !important',
      WebkitTextFillColor: '#fdfdfe !important',
      opacity: 1,
    },
  },

  newRowContainer: {
    display: 'flex',
    height: '27px',
    alignItems: 'center',
    alignSelf: 'flex-start',
    gap: '8px',
    '&:hover': {
      cursor: 'pointer',
    },
    marginBottom: 40,
  },

  addIcon: {
    color: '#B1A3B1',
    height: '24px',
    width: '24px',
  },

  addText: {
    fontSize: '16px',
    color: '#FFFFFF',
    display: 'flex',
    alignItems: 'center',
  },

  autocompleteMenuPaper: {
    marginTop: '4px',
    background: '#513E52',
    color: '#fff',
    borderRadius: '6px',
  },

  autocompleteOption: {
    fontSize: '16px !important',
    height: '43px !important',
    '&.Mui-focused': {
      backgroundColor: '#FFFFFF2E !important',
    },
    '&.Mui-selected': {
      backgroundColor: '#FFFFFF2E !important',
      '&:hover': {
        backgroundColor: '#FFFFFF2E !important',
      },
    },
  },

  autocompleteWrapper: {
    padding: '10px 0px',
    '& .MuiOutlinedInput-root': {
      color: '#fdfdfe',
      '& input': {
        height: '22px',
        boxSizing: 'border-box',
        color: '#fdfdfe',
        fontSize: '16px',
      },
      '& fieldset': {
        border: 0,
      },
      '&:hover fieldset': {
        border: 0,
      },
      '&.Mui-focused fieldset': {
        border: 0,
      },
    },
    '& .MuiAutocomplete-clearIndicator, & .MuiAutocomplete-popupIndicator': {
      color: '#fdfdfe',
    },
  },

  actionsContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: '8px',
  },

  actionsLabel: {
    padding: '8px',
  },

  cancelButton: {
    width: '110px',
    height: '40px',
    minHeight: '40px',
    borderRadius: '6px',
    border: '1px solid #8B808E',
    textTransform: 'none',
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: 'normal',
    letterSpacing: 'normal',
    color: '#ffffff',
  },

  arrowIcon: {
    color: '#FFFFFF99',
    fontSize: '24px',
    marginLeft: '4px',
    textAlign: 'right',
  },
  arrowIconList: {
    position: 'absolute',
    right: 0,
    top: '50%',
    transform: 'translateY(-55%)',
    cursor: 'pointer',
    zIndex: 1,
  },

  tabRoot: {
    minWidth: '45px',
    minHeight: '45px',
    width: '100%',
  },

  tab: {
    background: alpha('#fdfdfe', 0.3),
    color: '#ffffff',
  },

  calendar: {
    fontFamily: 'Roboto',
    color: '#fff !important',
    width: '100%',
    '& .DayPicker-wrapper': {
      width: '100%',
    },
    '& .DayPicker-Month': {
      width: '100%',
      height: '320px',
    },
    '& .DayPicker-Weekday': {
      color: '#fff',
    },
    '& .DayPicker-Day--disabled': {
      color: alpha('#fdfdfe', 0.2),
    },
    '& .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside)':
    {
      backgroundColor: theme.palette.secondary.main,
    },
    '& .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):hover':
    {
      backgroundColor: theme.palette.secondary.main,
    },
    '& .DayPicker:not(.DayPicker--interactionDisabled):hover': {
      backgroundColor: `${alpha('#fdfdfe', 0.1)} !important`,
    },
    '& .DayPicker-Day:not(.DayPicker-Day--disabled):not(.DayPicker-Day--selected):not(.DayPicker-Day--outside):hover':
    {
      backgroundColor: `${alpha('#fdfdfe', 0.1)} !important`,
    },
  },

  daysContainer: {
    padding: '0px 0px',
    margin: '0px 0px',
    justifyContent: 'space-between',
  },
}));
